//import actions from 'store/actions';

import reservationRequest from './reservation/reservationRequestActions';
import params from './paramsActions';
import moment from 'moment';

import currency from '@synergycms_core/store/customer/currencyAction';
import {apiGetter, momentLangCodes, langCodeCorrector} from '@synergycms_core/utils/api';
import storage from '@synergycms_core/utils/storage';
import {toLower} from 'ramda';
import {fromJS} from 'immutable';

export default {
    ...currency,
    RESERVATION_REQUEST: reservationRequest,
    PARAMS: params,
    CURRENCY_COUNTRY: {
        GET_ASYNC: () => {
            return (dispatch, getState) => {
                const apiBuscador = apiGetter('buscador'),
                    currencyCountryStorage = storage.getLocal('currency_country');
                if (getState().getIn(['customer', 'currencies']) && getState().getIn(['customer', 'country'])) {
                    return Promise.resolve();
                }
                //return Promise.resolve({ CountryCode: 'ES', CurrencyCode: 'EUR', ClientIP: 'unknownIP' });
                return currencyCountryStorage
                    ? Promise.resolve(currencyCountryStorage)
                    : apiBuscador.get('onLoadRequests.php', {action: 'gCCC'}, null).then(response => {
                        const currencyCountry = !(response.success === false)
                            ? response
                            : {CountryCode: 'ES', CurrencyCode: 'EUR', ClientIP: 'unknownIP'};
                        if (currencyCountry.CountryCode.toString().length > 0 && currencyCountry.ClientIP !== 'unknownIP') {
                            storage.setLocal('currency_country', currencyCountry);
                        }
                        return currencyCountry;
                    });
            };
        }
    },
    LANG_INFO: {
        GET: langinfo => {
            moment.locale(toLower(momentLangCodes(langCodeCorrector(langinfo.code))));
            langinfo.code = langCodeCorrector(langinfo.code);
            return langinfo;
        }
    },
    WEB_TYPE: {
        GET: webType => {
            return webType;
        }
    },
    CURRENT_MANAGEMENT_GROUP: {
        GET: (managementGroup) => {
            return managementGroup;
        }
    },
    CURRENT_HOTEL: {
        GET: (hotel) => {
            return hotel;
        }
    },
    SHOW_ADDRESSE: {
        GET: (showAddresseWindow) => {
            return !!parseInt(showAddresseWindow);
        }
    },
    SHOW_NEWS_CHECK: {
        GET: (showNewsCheckWindow) => {
            return !!parseInt(showNewsCheckWindow);
        }
    },
    RAW_REQUEST: {
        GET: (rawRequest) => {
            return fromJS(storage.get("gift_voucher_selection")) || rawRequest; //redirect;
        }
    },
    FORM_CURRENCY: {
        GET: (currency) => {
            return currency;
        }
    },
    TRACKING_ID: {
        GET: () => {
            // TODO amb ES6 hi ha la llibreria CRYPTO mes fiable per generar UUID, revisar opcions compatibles
            let trackingID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });

            return trackingID;
        }

    }


};
